require("es6-promise").polyfill();
require("promise.prototype.finally").shim();

require("jquery-slimscroll");
require("metismenu");

try {
  // window.Popper = require("popper.js").default;
  // window.$ = window.jQuery = require("jquery");

  require("bootstrap");
} catch (e) {}

import "datatables.net/js/jquery.dataTables.min";
import "datatables.net-bs4/js/dataTables.bootstrap4.min";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive/js/dataTables.responsive.min";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4.min";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "jquery-datatables-checkboxes/js/dataTables.checkboxes.min";

import "../hyper/src/scss/app.scss";
import "../hyper/src/scss/icons.scss";

import Vue from "vue";

import VueCompositionApi from "@vue/composition-api";
Vue.use(VueCompositionApi);

import { EventBus } from "@/utils/EventBus";

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

Vue.mixin({
  computed: {
    isDebug() {
      return process.env.NODE_ENV != "production";
    },
    isMobile() {
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        navigator.userAgent.toLowerCase()
      );
    },
  },
});

window.axios = require("axios");
// Intercept axios to handle 401 error on api request (ask user to authenticate again)
window.axios.interceptors.response.use(undefined, function(err) {
  if (
    err.response.status === 419 &&
    err.config &&
    !err.config.__isRetryRequest
  ) {
    return store.dispatch("auth/refreshState").then(
      (res) => {
        console.log(res);
        if (res.data && res.data.state != undefined) {
          err.config.__isRetryRequest = true;
          return axios(err.config);
        }

        return Promise.reject(err);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  } else if (
    err.response.status === 401 &&
    err.config &&
    (!err.config || !err.config.headers.__isLoginRequest) &&
    !err.config.__isRetryRequest
  ) {
    console.log("retry login");

    return new Promise(function(resolve, reject) {
      store.dispatch("auth/showLoginModal", {
        show: true,
        resolve,
        reject,
      });
    }).then(
      (res) => {
        // Just try again after login success
        err.config.__isRetryRequest = true;
        return axios(err.config);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
  return Promise.reject(err);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    $("body").removeClass("loading");
  },
}).$mount("#app");
